module.exports = __webpack_public_path__ + "media/images/pages/about/inclusion-in-the-classroom-4a89215287bbd2542811d02bd46e2b5e.jpg";